import { Theme } from "@mui/material";
import { t } from "i18next";
import {
  BookingType,
  NotSerializedBookingMode
} from "../../../features/Booking-Form/typings/booking-inputs";
import { PlaceType, ZoneType } from "../../../features/Login/typings/login.types";
import { ValidMaxAdvancedPerType } from "../form-selection-bookingType.component";
import { UnselectableText } from "../partial/form-selection.partial";

export const fitAndCorrectType = (
  typeName: string,
  placeTypes: PlaceType[],
  zoneTypes: ZoneType[]
) =>
  placeTypes.some(type => type.name === typeName) || zoneTypes.some(type => type.name === typeName);

/** single shared helper (core logic) to check valid max advanced booking time setting per booking type */
export const isBookingTypeSelectable = (
  type: BookingType,
  validMaxAdvancedPerType?: ValidMaxAdvancedPerType
): boolean => {
  if (!validMaxAdvancedPerType) return true;

  const map: Partial<Record<BookingType, boolean>> = {
    [BookingType.WORKPLACE]: validMaxAdvancedPerType.workplace,
    [BookingType.TEAM]: validMaxAdvancedPerType.workplace,
    [BookingType.PARKINGPLACE]: validMaxAdvancedPerType.parkingplace,
    [BookingType.ELECTRICCHARGINGSTATIONPLACE]: validMaxAdvancedPerType.electriccharging,
    [BookingType.CONFERENCEZONE]: validMaxAdvancedPerType.conference,
    [BookingType.VEHICLE]: validMaxAdvancedPerType.vehicle,
    [BookingType.VISITOR]: validMaxAdvancedPerType.visitor
  };

  return Boolean(map[type]);
};

export const isSelectable = (
  type: BookingType,
  theme: Theme,
  validMaxAdvancedPerType?: ValidMaxAdvancedPerType
) => {
  const basicStyle = {
    border: "unset",
    cursor: "pointer",
    "&:hover": { boxShadow: `0px 0px 0px 4px ${theme.palette.primary.main} inset;` }
  };
  const unselectableStyle = { border: "1px solid red", cursor: "default" };

  return isBookingTypeSelectable(type, validMaxAdvancedPerType) ? basicStyle : unselectableStyle;
};

export const onModeChangeBySelectable = (
  type: BookingType,
  onModeChange: (mode: NotSerializedBookingMode) => void,
  validMaxAdvancedPerType?: ValidMaxAdvancedPerType
) => {
  if (isBookingTypeSelectable(type, validMaxAdvancedPerType)) {
    onModeChange(type);
  }
};

export const showTooltipBySelectable = (
  type: BookingType,
  validMaxAdvancedPerType?: ValidMaxAdvancedPerType
) => {
  if (isBookingTypeSelectable(type, validMaxAdvancedPerType)) return null;

  return UnselectableText(t("_notAllowedBookingWithinMaximumAdvancedBookingTimePerType"));
};
